/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as LoginCallbackRouteImport } from './routes/login/callback'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated/search'
import { Route as AuthenticatedRulesRouteRouteImport } from './routes/_authenticated/rules/route'
import { Route as AuthenticatedGameViewRouteRouteImport } from './routes/_authenticated/game-view/route'
import { Route as AuthenticatedClipsRouteRouteImport } from './routes/_authenticated/clips/route'
import { Route as AuthenticatedRulesIndexRouteImport } from './routes/_authenticated/rules/index'
import { Route as AuthenticatedGameViewIndexRouteImport } from './routes/_authenticated/game-view/index'
import { Route as AuthenticatedClipsIndexRouteImport } from './routes/_authenticated/clips/index'
import { Route as AuthenticatedRulesNewRouteImport } from './routes/_authenticated/rules/new'
import { Route as AuthenticatedRulesRuleIdRouteImport } from './routes/_authenticated/rules/$ruleId'
import { Route as AuthenticatedGameViewGameClipsRouteImport } from './routes/_authenticated/game-view/game-clips'
import { Route as AuthenticatedGameViewCustomClippingRouteImport } from './routes/_authenticated/game-view/custom-clipping'
import { Route as AuthenticatedClipsMyReelsRouteImport } from './routes/_authenticated/clips/my-reels'
import { Route as AuthenticatedClipsMyCustomClipsRouteImport } from './routes/_authenticated/clips/my-custom-clips'
import { Route as AuthenticatedClipsMyClipsRouteImport } from './routes/_authenticated/clips/my-clips'
import { Route as AuthenticatedClipsAllCustomClipsRouteImport } from './routes/_authenticated/clips/all-custom-clips'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRulesRouteRoute = AuthenticatedRulesRouteRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGameViewRouteRoute =
  AuthenticatedGameViewRouteRouteImport.update({
    id: '/game-view',
    path: '/game-view',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClipsRouteRoute = AuthenticatedClipsRouteRouteImport.update({
  id: '/clips',
  path: '/clips',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRulesIndexRoute = AuthenticatedRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRulesRouteRoute,
} as any)
const AuthenticatedGameViewIndexRoute =
  AuthenticatedGameViewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGameViewRouteRoute,
  } as any)
const AuthenticatedClipsIndexRoute = AuthenticatedClipsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedClipsRouteRoute,
} as any)
const AuthenticatedRulesNewRoute = AuthenticatedRulesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedRulesRouteRoute,
} as any)
const AuthenticatedRulesRuleIdRoute =
  AuthenticatedRulesRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => AuthenticatedRulesRouteRoute,
  } as any)
const AuthenticatedGameViewGameClipsRoute =
  AuthenticatedGameViewGameClipsRouteImport.update({
    id: '/game-clips',
    path: '/game-clips',
    getParentRoute: () => AuthenticatedGameViewRouteRoute,
  } as any)
const AuthenticatedGameViewCustomClippingRoute =
  AuthenticatedGameViewCustomClippingRouteImport.update({
    id: '/custom-clipping',
    path: '/custom-clipping',
    getParentRoute: () => AuthenticatedGameViewRouteRoute,
  } as any)
const AuthenticatedClipsMyReelsRoute =
  AuthenticatedClipsMyReelsRouteImport.update({
    id: '/my-reels',
    path: '/my-reels',
    getParentRoute: () => AuthenticatedClipsRouteRoute,
  } as any)
const AuthenticatedClipsMyCustomClipsRoute =
  AuthenticatedClipsMyCustomClipsRouteImport.update({
    id: '/my-custom-clips',
    path: '/my-custom-clips',
    getParentRoute: () => AuthenticatedClipsRouteRoute,
  } as any)
const AuthenticatedClipsMyClipsRoute =
  AuthenticatedClipsMyClipsRouteImport.update({
    id: '/my-clips',
    path: '/my-clips',
    getParentRoute: () => AuthenticatedClipsRouteRoute,
  } as any)
const AuthenticatedClipsAllCustomClipsRoute =
  AuthenticatedClipsAllCustomClipsRouteImport.update({
    id: '/all-custom-clips',
    path: '/all-custom-clips',
    getParentRoute: () => AuthenticatedClipsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/clips': typeof AuthenticatedClipsRouteRouteWithChildren
  '/game-view': typeof AuthenticatedGameViewRouteRouteWithChildren
  '/rules': typeof AuthenticatedRulesRouteRouteWithChildren
  '/search': typeof AuthenticatedSearchRoute
  '/login/callback': typeof LoginCallbackRoute
  '/clips/all-custom-clips': typeof AuthenticatedClipsAllCustomClipsRoute
  '/clips/my-clips': typeof AuthenticatedClipsMyClipsRoute
  '/clips/my-custom-clips': typeof AuthenticatedClipsMyCustomClipsRoute
  '/clips/my-reels': typeof AuthenticatedClipsMyReelsRoute
  '/game-view/custom-clipping': typeof AuthenticatedGameViewCustomClippingRoute
  '/game-view/game-clips': typeof AuthenticatedGameViewGameClipsRoute
  '/rules/$ruleId': typeof AuthenticatedRulesRuleIdRoute
  '/rules/new': typeof AuthenticatedRulesNewRoute
  '/clips/': typeof AuthenticatedClipsIndexRoute
  '/game-view/': typeof AuthenticatedGameViewIndexRoute
  '/rules/': typeof AuthenticatedRulesIndexRoute
}
export interface FileRoutesByTo {
  '/search': typeof AuthenticatedSearchRoute
  '/login/callback': typeof LoginCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/clips/all-custom-clips': typeof AuthenticatedClipsAllCustomClipsRoute
  '/clips/my-clips': typeof AuthenticatedClipsMyClipsRoute
  '/clips/my-custom-clips': typeof AuthenticatedClipsMyCustomClipsRoute
  '/clips/my-reels': typeof AuthenticatedClipsMyReelsRoute
  '/game-view/custom-clipping': typeof AuthenticatedGameViewCustomClippingRoute
  '/game-view/game-clips': typeof AuthenticatedGameViewGameClipsRoute
  '/rules/$ruleId': typeof AuthenticatedRulesRuleIdRoute
  '/rules/new': typeof AuthenticatedRulesNewRoute
  '/clips': typeof AuthenticatedClipsIndexRoute
  '/game-view': typeof AuthenticatedGameViewIndexRoute
  '/rules': typeof AuthenticatedRulesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/clips': typeof AuthenticatedClipsRouteRouteWithChildren
  '/_authenticated/game-view': typeof AuthenticatedGameViewRouteRouteWithChildren
  '/_authenticated/rules': typeof AuthenticatedRulesRouteRouteWithChildren
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/login/callback': typeof LoginCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/clips/all-custom-clips': typeof AuthenticatedClipsAllCustomClipsRoute
  '/_authenticated/clips/my-clips': typeof AuthenticatedClipsMyClipsRoute
  '/_authenticated/clips/my-custom-clips': typeof AuthenticatedClipsMyCustomClipsRoute
  '/_authenticated/clips/my-reels': typeof AuthenticatedClipsMyReelsRoute
  '/_authenticated/game-view/custom-clipping': typeof AuthenticatedGameViewCustomClippingRoute
  '/_authenticated/game-view/game-clips': typeof AuthenticatedGameViewGameClipsRoute
  '/_authenticated/rules/$ruleId': typeof AuthenticatedRulesRuleIdRoute
  '/_authenticated/rules/new': typeof AuthenticatedRulesNewRoute
  '/_authenticated/clips/': typeof AuthenticatedClipsIndexRoute
  '/_authenticated/game-view/': typeof AuthenticatedGameViewIndexRoute
  '/_authenticated/rules/': typeof AuthenticatedRulesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clips'
    | '/game-view'
    | '/rules'
    | '/search'
    | '/login/callback'
    | '/clips/all-custom-clips'
    | '/clips/my-clips'
    | '/clips/my-custom-clips'
    | '/clips/my-reels'
    | '/game-view/custom-clipping'
    | '/game-view/game-clips'
    | '/rules/$ruleId'
    | '/rules/new'
    | '/clips/'
    | '/game-view/'
    | '/rules/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/search'
    | '/login/callback'
    | '/'
    | '/clips/all-custom-clips'
    | '/clips/my-clips'
    | '/clips/my-custom-clips'
    | '/clips/my-reels'
    | '/game-view/custom-clipping'
    | '/game-view/game-clips'
    | '/rules/$ruleId'
    | '/rules/new'
    | '/clips'
    | '/game-view'
    | '/rules'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/clips'
    | '/_authenticated/game-view'
    | '/_authenticated/rules'
    | '/_authenticated/search'
    | '/login/callback'
    | '/_authenticated/'
    | '/_authenticated/clips/all-custom-clips'
    | '/_authenticated/clips/my-clips'
    | '/_authenticated/clips/my-custom-clips'
    | '/_authenticated/clips/my-reels'
    | '/_authenticated/game-view/custom-clipping'
    | '/_authenticated/game-view/game-clips'
    | '/_authenticated/rules/$ruleId'
    | '/_authenticated/rules/new'
    | '/_authenticated/clips/'
    | '/_authenticated/game-view/'
    | '/_authenticated/rules/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginCallbackRoute: typeof LoginCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rules': {
      id: '/_authenticated/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AuthenticatedRulesRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/game-view': {
      id: '/_authenticated/game-view'
      path: '/game-view'
      fullPath: '/game-view'
      preLoaderRoute: typeof AuthenticatedGameViewRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clips': {
      id: '/_authenticated/clips'
      path: '/clips'
      fullPath: '/clips'
      preLoaderRoute: typeof AuthenticatedClipsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rules/': {
      id: '/_authenticated/rules/'
      path: '/'
      fullPath: '/rules/'
      preLoaderRoute: typeof AuthenticatedRulesIndexRouteImport
      parentRoute: typeof AuthenticatedRulesRouteRoute
    }
    '/_authenticated/game-view/': {
      id: '/_authenticated/game-view/'
      path: '/'
      fullPath: '/game-view/'
      preLoaderRoute: typeof AuthenticatedGameViewIndexRouteImport
      parentRoute: typeof AuthenticatedGameViewRouteRoute
    }
    '/_authenticated/clips/': {
      id: '/_authenticated/clips/'
      path: '/'
      fullPath: '/clips/'
      preLoaderRoute: typeof AuthenticatedClipsIndexRouteImport
      parentRoute: typeof AuthenticatedClipsRouteRoute
    }
    '/_authenticated/rules/new': {
      id: '/_authenticated/rules/new'
      path: '/new'
      fullPath: '/rules/new'
      preLoaderRoute: typeof AuthenticatedRulesNewRouteImport
      parentRoute: typeof AuthenticatedRulesRouteRoute
    }
    '/_authenticated/rules/$ruleId': {
      id: '/_authenticated/rules/$ruleId'
      path: '/$ruleId'
      fullPath: '/rules/$ruleId'
      preLoaderRoute: typeof AuthenticatedRulesRuleIdRouteImport
      parentRoute: typeof AuthenticatedRulesRouteRoute
    }
    '/_authenticated/game-view/game-clips': {
      id: '/_authenticated/game-view/game-clips'
      path: '/game-clips'
      fullPath: '/game-view/game-clips'
      preLoaderRoute: typeof AuthenticatedGameViewGameClipsRouteImport
      parentRoute: typeof AuthenticatedGameViewRouteRoute
    }
    '/_authenticated/game-view/custom-clipping': {
      id: '/_authenticated/game-view/custom-clipping'
      path: '/custom-clipping'
      fullPath: '/game-view/custom-clipping'
      preLoaderRoute: typeof AuthenticatedGameViewCustomClippingRouteImport
      parentRoute: typeof AuthenticatedGameViewRouteRoute
    }
    '/_authenticated/clips/my-reels': {
      id: '/_authenticated/clips/my-reels'
      path: '/my-reels'
      fullPath: '/clips/my-reels'
      preLoaderRoute: typeof AuthenticatedClipsMyReelsRouteImport
      parentRoute: typeof AuthenticatedClipsRouteRoute
    }
    '/_authenticated/clips/my-custom-clips': {
      id: '/_authenticated/clips/my-custom-clips'
      path: '/my-custom-clips'
      fullPath: '/clips/my-custom-clips'
      preLoaderRoute: typeof AuthenticatedClipsMyCustomClipsRouteImport
      parentRoute: typeof AuthenticatedClipsRouteRoute
    }
    '/_authenticated/clips/my-clips': {
      id: '/_authenticated/clips/my-clips'
      path: '/my-clips'
      fullPath: '/clips/my-clips'
      preLoaderRoute: typeof AuthenticatedClipsMyClipsRouteImport
      parentRoute: typeof AuthenticatedClipsRouteRoute
    }
    '/_authenticated/clips/all-custom-clips': {
      id: '/_authenticated/clips/all-custom-clips'
      path: '/all-custom-clips'
      fullPath: '/clips/all-custom-clips'
      preLoaderRoute: typeof AuthenticatedClipsAllCustomClipsRouteImport
      parentRoute: typeof AuthenticatedClipsRouteRoute
    }
  }
}

interface AuthenticatedClipsRouteRouteChildren {
  AuthenticatedClipsAllCustomClipsRoute: typeof AuthenticatedClipsAllCustomClipsRoute
  AuthenticatedClipsMyClipsRoute: typeof AuthenticatedClipsMyClipsRoute
  AuthenticatedClipsMyCustomClipsRoute: typeof AuthenticatedClipsMyCustomClipsRoute
  AuthenticatedClipsMyReelsRoute: typeof AuthenticatedClipsMyReelsRoute
  AuthenticatedClipsIndexRoute: typeof AuthenticatedClipsIndexRoute
}

const AuthenticatedClipsRouteRouteChildren: AuthenticatedClipsRouteRouteChildren =
  {
    AuthenticatedClipsAllCustomClipsRoute:
      AuthenticatedClipsAllCustomClipsRoute,
    AuthenticatedClipsMyClipsRoute: AuthenticatedClipsMyClipsRoute,
    AuthenticatedClipsMyCustomClipsRoute: AuthenticatedClipsMyCustomClipsRoute,
    AuthenticatedClipsMyReelsRoute: AuthenticatedClipsMyReelsRoute,
    AuthenticatedClipsIndexRoute: AuthenticatedClipsIndexRoute,
  }

const AuthenticatedClipsRouteRouteWithChildren =
  AuthenticatedClipsRouteRoute._addFileChildren(
    AuthenticatedClipsRouteRouteChildren,
  )

interface AuthenticatedGameViewRouteRouteChildren {
  AuthenticatedGameViewCustomClippingRoute: typeof AuthenticatedGameViewCustomClippingRoute
  AuthenticatedGameViewGameClipsRoute: typeof AuthenticatedGameViewGameClipsRoute
  AuthenticatedGameViewIndexRoute: typeof AuthenticatedGameViewIndexRoute
}

const AuthenticatedGameViewRouteRouteChildren: AuthenticatedGameViewRouteRouteChildren =
  {
    AuthenticatedGameViewCustomClippingRoute:
      AuthenticatedGameViewCustomClippingRoute,
    AuthenticatedGameViewGameClipsRoute: AuthenticatedGameViewGameClipsRoute,
    AuthenticatedGameViewIndexRoute: AuthenticatedGameViewIndexRoute,
  }

const AuthenticatedGameViewRouteRouteWithChildren =
  AuthenticatedGameViewRouteRoute._addFileChildren(
    AuthenticatedGameViewRouteRouteChildren,
  )

interface AuthenticatedRulesRouteRouteChildren {
  AuthenticatedRulesRuleIdRoute: typeof AuthenticatedRulesRuleIdRoute
  AuthenticatedRulesNewRoute: typeof AuthenticatedRulesNewRoute
  AuthenticatedRulesIndexRoute: typeof AuthenticatedRulesIndexRoute
}

const AuthenticatedRulesRouteRouteChildren: AuthenticatedRulesRouteRouteChildren =
  {
    AuthenticatedRulesRuleIdRoute: AuthenticatedRulesRuleIdRoute,
    AuthenticatedRulesNewRoute: AuthenticatedRulesNewRoute,
    AuthenticatedRulesIndexRoute: AuthenticatedRulesIndexRoute,
  }

const AuthenticatedRulesRouteRouteWithChildren =
  AuthenticatedRulesRouteRoute._addFileChildren(
    AuthenticatedRulesRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedClipsRouteRoute: typeof AuthenticatedClipsRouteRouteWithChildren
  AuthenticatedGameViewRouteRoute: typeof AuthenticatedGameViewRouteRouteWithChildren
  AuthenticatedRulesRouteRoute: typeof AuthenticatedRulesRouteRouteWithChildren
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedClipsRouteRoute: AuthenticatedClipsRouteRouteWithChildren,
  AuthenticatedGameViewRouteRoute: AuthenticatedGameViewRouteRouteWithChildren,
  AuthenticatedRulesRouteRoute: AuthenticatedRulesRouteRouteWithChildren,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginCallbackRoute: LoginCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
